/**
 * First we will load all of this project's JavaScript dependencies which
 * includes React and other helpers. It's a great starting point while
 * building robust, powerful web applications using React + Laravel.
 */
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import 'babel-polyfill';
import 'isomorphic-fetch';
import App from './layout/App/App';
import * as Sentry from '@sentry/browser';

if (process.env.NODE_ENV === 'production') {
	Sentry.init({ dsn: 'https://10181e6d7f5042ffbb5ddfc9dcd9c1d9@sentry2.intdev.exetel.com.au/20' });
}

/**
 * Next, we will create a fresh React component instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */
ReactDOM.render(
    <BrowserRouter>
        <App />
    </BrowserRouter>
, document.getElementById('root'));



// WEBPACK FOOTER //
// ./resources/assets/js/app.js